module.exports = __webpack_public_path__ + "img/orienteering_1.b831cdc9.jpg";